module.exports = __webpack_public_path__ + "static/a1d1-3-358bab02bd208364ca6eba6d9128b3d9.svg";